(ns renolit-roofing-service.view.service.visit-program
  (:require [renolit-roofing-service.layout.components :as layout.components]
            [re-frame.core :as rf]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.util.google-maps :as google-maps]
            [clojure.string :as str]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.util.work-package :as util.work-package]))

(defn zone-pill
  [zone-name]
  [:span.zone-pill zone-name])

(defn task-block
  [task-type occurrences]
  [:div.task-card
   [:div.task-card__title
    (t [(keyword (str "domain.choices.task-type/" (name task-type)))])]
   (for [{:keys [subzone-name comment poi-id]} occurrences]
     ^{:key (str poi-id "-" subzone-name "-" comment)}
     [:div.task-card__body
      [:div.task-card__zones
       [zone-pill subzone-name]]
      (when (and comment (not (str/blank? comment)))
        [:div.task-card__comments
         [layout.icon/icon {:key :message :class "task-card__comments-icon"}]
         [:span.task-card__comments-text comment]])])])

(defn poi-type-section
  [poi-type tasks-by-task-type]
  [:div.poi-type-section
   [:span
    (t [(keyword (str "domain.choices.revision-type/" (name poi-type)))])]
   (for [[task-type occurrences] (sort-by (fn [[k _]] (name k)) tasks-by-task-type)]
     ^{:key (str poi-type "-" task-type)}
     [task-block task-type occurrences])])

(defn wp-type-section
  [wp-type poi-types]
  [layout.components/collapsable-section
   {:title (t [(keyword (str "domain.choices.wp-type/" (name wp-type)))])
    :start-open true
    :class "collapsable-section--nested"}
   (for [poi-type (sort (keys poi-types))]
     (let [tasks-by-task-type (get poi-types poi-type)]
       (when (seq tasks-by-task-type)
         ^{:key (str wp-type "-" poi-type)}
         [poi-type-section poi-type tasks-by-task-type])))])

(defn wp-section
  [wp wp-types]
  [layout.components/collapsable-section
   {:title (t [(keyword (str "domain.choices.wp/" (name wp)))])
    :icon [google-maps/wp-icon wp]
    :start-open true}
   (for [[wp-type poi-types] (sort-by (fn [[k _]] (name k)) wp-types)]
     ^{:key (str wp "-" wp-type)}
     [wp-type-section wp-type poi-types])])

(defn work-packages-panel
  [nodes]
  (let [idx (util.work-package/group-tasks nodes)]
    [:div
     (for [[wp wp-types] (sort-by (fn [[k _]] (name k)) idx)]
       ^{:key (str wp)}
       [wp-section wp wp-types])]))

(defn main
  [_state]
  (let [zones (rf/subscribe [::google-maps/zones])]
    (fn []
      [:div.visit-program
       [work-packages-panel @zones]])))
